<!--suppress JSUnresolvedVariable -->
<template>
  <div class="careers-detail">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-info">
        <h1 class="animated fadeInDown">招贤纳士</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>

    <div class="container content my-5">
      <!-- 当前位置 -->
      <div class="text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <router-link to="/toRecruitmentCenter" class="text-muted"
          >招贤纳士</router-link
        >
        /
        <a href="#" class="text-muted">岗位详情</a>
      </div>

      <h2 class="text-center mt-3" style="font-size: 20px">
        {{ jobDetail.jobName }}
      </h2>
      <div
        class="text-center border-bottom text-secondary pb-2 mb-3 d-flex justify-content-center"
      >
        <span class="text-muted"
          >时间：
          <span class="text-danger">{{ jobDetail.publishTime }}</span>
        </span>
        <span class="text-muted ml-5"
          >访问量：
          <span class="text-info">{{ jobDetail.jobViews }}</span>
        </span>
      </div>
      <div class="job-content mb-3" v-html="jobDetail.jobContent"></div>
      <div class="text-secondary">
        <p>
          上一篇：
          <a
            href="#"
            type="primary"
            v-if="preJob.jobName !== undefined"
            @click="updateJobViews(preJob.jobId)"
          >
            {{ preJob.jobName }}
          </a>
          <a v-else class="btn text-muted disabled">没有了</a>
        </p>
        <p>
          下一篇：
          <a
            href="#"
            type="primary"
            v-if="nextJob.jobName !== undefined"
            @click="updateJobViews(nextJob.jobId)"
          >
            {{ nextJob.jobName }}
          </a>
          <a v-else class="btn text-muted disabled">没有了</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CareersDetail",
  data() {
    return {
      sectionSubTitle: "",
      backgroundUrl: "",
      logSys: 1,
      jobId: this.$route.params.jobId,
      jobDetail: {},
      preJob: {},
      nextJob: {}
    };
  },
  mounted() {
    this.isSystem();
    this.getNavById();
    this.getJobDetailById();
    this.preOneJob(this.jobId, 0);
    this.nextOneJob(this.jobId, 1);
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.logSys = 3;
      } else {
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 5)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.backgroundUrl = resp.data.data.bannerImg;
            this.sectionSubTitle = resp.data.data.subTitle;
          }
        })
        .catch();
    },
    getJobDetailById() {
      this.axios
        .get("/job/getJobDetailById/" + this.jobId)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.jobDetail = resp.data.data;
          }
        })
        .catch();
    },
    preOneJob(jobId, type) {
      this.axios
        .get("/job/findOneJob", {
          params: {
            jobId: jobId,
            type: type
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (resp.data.data !== null) {
              this.preJob = resp.data.data;
            }
          }
        })
        .catch();
    },
    nextOneJob(jobId, type) {
      this.axios
        .get("/job/findOneJob", {
          params: {
            jobId: jobId,
            type: type
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (resp.data.data !== null) {
              this.nextJob = resp.data.data;
            }
          }
        })
        .catch();
    },
    updateJobViews(jobId) {
      this.axios
        .put("/job/updateJobViews/" + jobId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$router
              .push({ name: "CareersDetail", params: { jobId: jobId } })
              .catch();
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.careers-detail {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  .content {
    .job-content {
      h4 {
        font-size: 16px;
        font-family: 楷体, serif;
        font-weight: bolder;
      }
    }
  }
}
</style>
